import React from 'react'
import { Outlet } from 'react-router-dom'
import EmployeeSalaryNavbar from '../../../Components/EmployeeSalaryNavbar'

function EmpSalary() {
    return (
        <>
                <div className=''>
                    <div >
                        <EmployeeSalaryNavbar />
                    </div>

                    <div className='mt-4'>
                        <Outlet />
                    </div>
                </div>
        </>
    )
}

export default EmpSalary;